import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGlobalStore } from '../services/store/store'

const excludedPaths = [
	'/login',
	'/validate-auth-code',
	'/privacy-policy',
	'/cookie-policy',
	'/content-disclaimer',
	'/copyright-statement',
	'/accessibility-statement'
]
const useRedirect = () => {
	const location = useLocation()
	const navigate = useNavigate()
	const userToken = useGlobalStore((state) => state.userToken)
	const setRedirectPath = useGlobalStore((state) => state.setRedirectPath)
	const clearRedirectPath = useGlobalStore((state) => state.clearRedirectPath)
	const redirectPath = useGlobalStore((state) => state.redirectPath)

	useEffect(() => {
		const isExcludedPath = excludedPaths.includes(location.pathname)

		if (!userToken && !isExcludedPath) {
			setRedirectPath(location.pathname)
			navigate('/login', { replace: true })
		}

		if (userToken && redirectPath && location.pathname !== redirectPath) {
			navigate(redirectPath, { replace: true })
			clearRedirectPath()
		}
	}, [
		userToken,
		redirectPath,
		location.pathname,
		navigate,
		setRedirectPath,
		clearRedirectPath
	])
}

export default useRedirect
